import { getVendorByNumberRequest, getVendorsRequest, getPreferredVendorsRequest, updateVendorRequest } from '../requests';
import rdbClient from 'rdb-client';

async function getVendorByNumber({ state, commit }, vendorNumber) {
	let vendor = state.vendors.find(vendor => vendor.vendorNumber === vendorNumber);
	if (vendor) return vendor;
	try {
		let vendor = await getVendorByNumberRequest(vendorNumber);
		commit('setVendors', [...state.vendors, vendor]);
		return vendor;
	} catch (err) {
		console.error(`Get vendor by number failed: ${err}`);
		return false;
	}
}

async function getVendors({ commit }) {
	let response = [];
	try {
		response = await getVendorsRequest();
		commit('setVendors', response);
	} catch (err) {
		console.log(`Set Vendors failed: ${  err}`);
	}
	return response;
}

async function statelessGetVendors() {
	return getVendorsRequest();
}

async function updateVendor({ commit }, { originalVendor, updatedVendor }) {
	let patch = rdbClient.createPatch(originalVendor, updatedVendor);
	let response = await updateVendorRequest(originalVendor.id, patch);
	commit('setVendor', response);
}

async function getPreferredVendors({ commit }) {
	let response = [];
	try {
		response = await getPreferredVendorsRequest();
		commit('setPreferredVendors', response);
	} catch (err) {
		console.log(`Set Preferred Vendors failed: ${  err}`);
	}
	return response;
}

async function updateVendorEmail({ state, commit }, { vendor, newEmail }) {
	let patch = rdbClient.createPatch(vendor, { ...vendor, email: newEmail } );

	try {
		let response = await updateVendorRequest(vendor.id, patch);
		let newVendorsArray = state.vendors.map(v => v.id === response.id ? response : v);
		commit('setVendors', newVendorsArray);
		return response;
	} catch (err) {
		throw new Error('failedToUpdateVendorEmail');
	}
}

export default {
	getVendorByNumber,
	getVendors,
	statelessGetVendors,
	getPreferredVendors,
	updateVendor,
	updateVendorEmail,
};
